<template>
  <div class="leftres">
    <div>
      <div class="inputtop">
        <div class="top">
          <span style="color: #E71D43;">*</span><span style="font-size: 14px;">发票图片上传:</span>
          <CommonbtnUpLoad style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF" title="预览" fontSize="1px" @getFile="preview" types="fileImg" width="50px" height="32px" :src="require('@/assets/icon/icon-add.png')">
          </CommonbtnUpLoad>
          <!-- <Btn title="预览" :src="require('@/assets/icon/icon-add.png')" width="50px" height="32px" backgroundColor="#FFFFFF" color="#333333"></Btn> -->
          <Btn title="四要素校验" :src="require('@/assets/icon/bc.png')" @btnclick="fourElements" width="84px" height="32px" backgroundColor="#FFFFFF" color="#333333"></Btn>
        </div>
        <div class="TableBox" style="height: 1px;margin: 14px;background-color: #F0F0F0;">
        </div>
        <div class="TableBox" >
          <div style="display: inline-block;" v-for="(item , index) of formdata" :key="index">
            <Commondropdownlist ref="pccxyRef" :widths="item.widths" :options="item.options" :lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width"  :min="item.min" :max="item.max" ></Commondropdownlist>
          </div>
        </div>
        <div>
          <div style="display: inline-block;margin-left: 12px; position: absolute;margin-top:15px;">
            输出参数:
          </div>
          <div v-html="html"  style="width: 1270px; display: inline-block;height: 440px;border: 1px solid red;margin-left: 95px;margin-top:20px;border: 1px solid #E6E6E6; overflow:scroll;">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../../../components/commongroup.vue'
import Dialog from '../../../../components/dialog.vue'
import Btn from '../../../../components/common-btn.vue'
import CommonbtnUpLoad from '../../../../components/common-upload.vue'
import formdata from './formData/inputdata'
import utils from '../../../../common/utils'
import {
  HelperCheckInvoiceDemo,
  HelperCheckInvoiceDemoByStandard,
  HelperCheckWay
} from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    Dialog,
    CommonbtnUpLoad,
    Btn
  },
  data() {
    return {
      dialogVisibles: false,
      formdata: [],
      qus: [],
      html: null,
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false,
        submit: false,
        skip: false,//跳过
        reset: false, //重置
      },
    }
  },
  mounted() {
    this.formdata = JSON.parse(JSON.stringify(formdata))
    this.QX()
    this.helperCheckWay()
  },
  methods: {
    QX() {
      let data = JSON.parse(localStorage.getItem("MenusData"))
      let MenuID = this.$route.query.MenuID
      data.Menus.map((item, index) => {
        if (item.NodeID == 31) {
          item.Nodes.map((items, indexs) => {
            if (items.NodeID == 50) {
              this.qus = items.Nodes
            }
          })
        }
      })
      //console.log(this.qus);
      if (this.qus) {
        this.qus.map((item, index) => {
          if (item.NodeName == 'add') {
            this.qx.add = true
          } else if (item.NodeName == 'edit') {
            this.qx.update = true
          } else if (item.NodeName == 'delete') {
            this.qx.del = true
          } else if (item.NodeName == 'stopif') {
            this.qx.del = true
          } else if (item.NodeName == 'assignment') {
            this.qx.assignment = true
          } else if (item.NodeName == 'enabled') {
            this.qx.enabled = true
          } else if (item.NodeName == 'skip') {
            this.qx.skip = true
          } else if (item.NodeName == 'reset') {
            this.qx.reset = true
          }
        })
      }
    },
    // 预览
    async helperCheckInvoiceDemo(file) {
      if (file) {
        const loading = this.$loading({
          lock: true,
          text: '上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(255,255,255,0.3)'
        });
        let formData = new FormData()
        formData.append("file", file)
        let res = await HelperCheckInvoiceDemo(formData)
        if (res.code == 0) {
          this.formdata[0].inputdata = res.data.InvoiceNo
          this.formdata[1].inputdata = res.data.SBDate
          this.formdata[2].inputdata = res.data.CheckWay
          this.formdata[3].inputdata = res.data.VerifyCode
          this.formdata[4].inputdata = res.data.SBCode
          this.formdata[5].inputdata = res.data.InvoiceAmt
          this.html = `<pre>${JSON.stringify(JSON.parse(res.data.GetText), null, 4)}</pre>`
          this.$message({
            type: 'success',
            message: res.message
          })

          loading.close();
        } else {
          this.$message({
            type: 'error',
            message: res.message
          })
          loading.close();
        }
        loading.close();
      }
    },
    // 预览
    preview(file) {
      this.helperCheckInvoiceDemo(file)
    },
    // 四要素
    async helperCheckInvoiceDemoByStandard() {
      let {
        code,
        data
      } = await HelperCheckInvoiceDemoByStandard({
        invoiceNo: this.$refs.pccxyRef[0].modelvalue,
        sbCode: this.$refs.pccxyRef[4].modelvalue,
        sbDate: this.$refs.pccxyRef[1].modelvalue,
        verifyCode: this.$refs.pccxyRef[3].modelvalue,
        checkWay: this.$refs.pccxyRef[2].modelvalue,
        invoiceAmt: this.$refs.pccxyRef[5].modelvalue,
      })
      if (code == 0) {
        this.html = `<pre>${JSON.stringify(JSON.parse(data.GetText), null, 4)}</pre>`
      }
    },
    // 四要素
    fourElements() {
      this.helperCheckInvoiceDemoByStandard()
    },
    // 发票类型下拉
    async helperCheckWay() {
      let {
        code,
        data
      } = await HelperCheckWay({})
      if (code == 0) {
        this.$refs.pccxyRef[2].options = []
        data.map((item, index) => {
          let obj = {
            key: item.Value,
            value: item.Text
          }
          this.$refs.pccxyRef[2].options.push(obj)
        })
      }
    },
    reset() {

      this.dialogVisibles = true
    },
    cancel() {
      //console.log('name')
      this.dialogVisibles = false
    },
    dialogOK() {
      //console.log('name2')
      this.dialogVisibles = false
    },
    startTime(val) {
      //console.log("开始时间", val);
    },
    endTime(val) {
      //console.log("结束时间", val);
    }
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 680px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 24px;
  font-size: 14px;

  .top {
    margin-left: 24px;
  }
}
</style>